/* This will be used to generate a
list of widgets provided by feed and
mapped in file for various section */

import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { getImageFromImageObject } from 'components/Image/utils';
import makeRequest from 'utils/makeRequest';
import Image from 'components/Image';
//import { bindGa } from 'helpers/analytics';
import s from './ListingWidget.scss';

function getStyleClasses(classesSpaceSep, styleObj) {
  if (typeof classesSpaceSep === 'string' && classesSpaceSep !== '') {
    const classes = classesSpaceSep.split(' ').map(item => styleObj[item]);
    return classes.join(' ');
  }
  return '';
}

function isStringExist(obj) {
  if (typeof obj === 'string' && obj.trim().length > 0) {
    return true;
  }
  return false;
}
class ListingWidget extends React.Component {
  constructor() {
    super();
    this.state = {
      clientListData: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { item } = this.props;
    const url = item.dataUrl;
    // let url = item.dataUrl;
    // if (!__PROD__ && typeof item.dataUrl !== 'undefined') {
    //   url = item.dataUrl.replace('timesofindia', 'toidev');
    // }
    if (url) {
      makeRequest
        .get(url)
        .then(data => {
          if (data.status === 200 && data.data) {
            this.setState({
              clientListData: data.data,
            });
          }
        })
        .catch(err => console.log(err));
    }
  };

  getlist(itemNode, listData) {
    const lists = listData;
    //const imageUrl = 'https://static.toiimg.com/photo/';
    const gaPrefix = this.props.gaPrefix || itemNode.gaPrefix;
    const gaCategory = this.props.gaCategory || `${gaPrefix}_${itemNode.id}`;
    const { fromEtimesArticle } = this.props;
    let gaAction = '';
    if (
      gaCategory === 'liveblog_new_web' ||
      gaCategory === 'liveblog_new_mweb'
    ) {
      gaAction = 'top_stories_rhs';
    } else if (this.props.gaAction) {
      gaAction = this.props.gaAction;
    } else {
      gaAction =
        typeof itemNode.id !== 'undefined' && itemNode.id !== ''
          ? `${gaPrefix}_${itemNode.id}`
          : `${gaPrefix}`;
    }
    const gaSecname =
      typeof itemNode.id !== 'undefined' && itemNode.id !== ''
        ? itemNode.id
        : `${itemNode.name}` || '';
    let dataGaPartialVal = `${gaCategory}|${gaAction}|${
      fromEtimesArticle ? '' : `${gaSecname}_story`
    }`;
    if (itemNode.id === 'spotlight_articles') {
      dataGaPartialVal = `${dataGaPartialVal}_asrhs`;
    }
    const { maxChars, hideImage } = this.props;
    return (
      lists &&
      lists.length > 0 &&
      lists.map((item, index) => (
        <React.Fragment key={item.id || item.hl}>
          {isStringExist(item.hl) && (
            //<li className={`${item.primeid ? s.prime : ''}`}>
            <li>
              {!!itemNode.sectionInfo &&
                isStringExist(item.sec) && (
                  <span className={s.category}>{item.sec}</span>
                )}
              <Link
                to={item.wu}
                title={item.hl}
                //spa={item.isspa === '1'}
                data-ga={`${dataGaPartialVal}${
                  fromEtimesArticle ? '' : '_'
                }${index + 1}-${item.wu}`}
                onClick={
                  item.wu && item.wu.indexOf('/videoshow/') !== -1
                    ? e => this.handleVideosOnClick(e, item.wu, item.id, item)
                    : false
                }
              >
                {!hideImage &&
                  item.imageid && (
                    <span className={s.thumbs_wrapper}>
                      <span className={s.content}>
                        <Image
                          key={item.imageid}
                          msid={item.imageid}
                          src={getImageFromImageObject({
                            id: item.imageid,
                            version: item.imgsize,
                          })}
                          lazyload
                          placeHolderSrc="https://static.toiimg.com/photo/34824568.cms"
                          offsetVertical={100}
                          width={this.props.imgWidth}
                          alt={item.hl || ''}
                        />
                        {/* <img
                        src={
                          isStringExist(item.imageid) &&
                          item.imageid.indexOf('http') >= 0
                            ? item.imageid
                            : `${imageUrl}${item.imageid}`
                        }
                        alt={item.hl}
                      /> */}
                      </span>
                    </span>
                  )}
                {!hideImage &&
                  item.image && (
                    <span className={s.thumbs_wrapper}>
                      <span className={s.content}>
                        <Image
                          key={item.image.id}
                          msid={item.image.id}
                          src={getImageFromImageObject(item.image)}
                          lazyload
                          placeHolderSrc="https://static.toiimg.com/photo/34824568.cms"
                          offsetVertical={100}
                          width={this.props.imgWidth}
                          alt={item.hl || ''}
                        />
                      </span>
                    </span>
                  )}
                {item.hl && (
                  <span className={s.thumb_txt}>
                    {maxChars > 0 && item.hl.length > maxChars
                      ? `${item.hl.substring(0, maxChars)}...`
                      : item.hl}
                    {isStringExist(item.type || item.tn) &&
                      !(item.type === 'article' || item.tn === 'article') && (
                        <i className={`${s.icon} ${s[item.type || item.tn]}`} />
                      )}
                  </span>
                )}
              </Link>
            </li>
          )}
        </React.Fragment>
      ))
    );
  }
  getMoreLink = itemNode => {
    if (itemNode && itemNode.moreText) {
      const gaPrefix = this.props.gaPrefix || itemNode.gaPrefix;
      const gaCategory = this.props.gaCategory || `${gaPrefix}_${itemNode.id}`;
      let gaAction = '';
      if (this.props.gaAction) {
        gaAction = this.props.gaAction;
      } else {
        gaAction =
          typeof itemNode.id !== 'undefined' && itemNode.id !== ''
            ? `${gaPrefix}_${itemNode.id}`
            : `${gaPrefix}`;
      }
      const gaLabel = itemNode.gaLabel || '';
      const gaSecname =
        typeof itemNode.id !== 'undefined' && itemNode.id !== ''
          ? itemNode.id
          : gaLabel;
      const dataGaVal = `${gaCategory}|${gaAction}|${gaSecname}_moreStories`;
      const target = this.props.morlinkOpenInNewTab === 'yes' ? '_blank' : '';
      return (
        <div className={s.moreStoriesBtn}>
          <Link
            to={itemNode.link}
            title={itemNode.moreText}
            //spa={itemNode.isspa === '1'}
            data-ga={dataGaVal}
            target={target}
          >
            {itemNode.moreText}
          </Link>
        </div>
      );
    }
    return null;
  };
  render() {
    let themeClassName;
    let listData;
    const { item, className, isWapView } = this.props;
    const target = this.props.morlinkOpenInNewTab === 'yes' ? '_blank' : '';
    const isServerListDataExist = item && item.data && item.data.length;
    if (!isServerListDataExist && !this.state.clientListData) {
      if (item.dataUrl) {
        return <div className={s.loading_skeleton} />;
      }
      return null;
    }
    if (this.state.clientListData) {
      listData = this.state.clientListData;
    } else if (isServerListDataExist) {
      listData = item.data;
    }
    if (item.theme) {
      themeClassName = getStyleClasses(item.theme, s);
    } else {
      themeClassName = getStyleClasses('default_list', s);
    }
    const h2HTML = item.link ? (
      <Link
        to={item.link}
        title={item.name}
        target={target}
        data-newga={`click#${item.link}${
          this.props.gaCategory ? `#${this.props.gaCategory}` : ''
        }`}
        //spa={itemNode.isspa === '1'}
      >
        {item.name}
      </Link>
    ) : (
      <span title={item.name}>{item.name}</span>
    );
    return (
      <div className={`${themeClassName} ${className}`}>
        <h2>
          <i />
          {h2HTML}
        </h2>
        <ul>{this.getlist(item, listData)}</ul>
        {this.getMoreLink(item, listData)}
        {isWapView && (
          <div className={s.widgetBottomDiv}>
            <i />
          </div>
        )}
      </div>
    );
  }
}

ListingWidget.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    theme: PropTypes.string,
    sectionInfo: PropTypes.bool,
    id: PropTypes.string,
    link: PropTypes.string,
    moreText: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.object),
    dataUrl: PropTypes.string,
  }),
  imgWidth: PropTypes.number,
  gaCategory: PropTypes.string,
  gaPrefix: PropTypes.string,
  className: PropTypes.string,
  maxChars: PropTypes.number,
  isWapView: PropTypes.bool,
  hideImage: PropTypes.bool,
  morlinkOpenInNewTab: PropTypes.string,
  gaAction: PropTypes.string,
  fromEtimesArticle: PropTypes.bool,
};
ListingWidget.defaultProps = {
  item: {},
  imgWidth: 300,
  gaCategory: '',
  gaPrefix: '',
  className: '',
  maxChars: 80,
  isWapView: false,
  hideImage: false,
  morlinkOpenInNewTab: '',
  gaAction: '',
  fromEtimesArticle: false,
};

export default ListingWidget;
